import { useViewPort } from "@website/hooks/viewport";
import { TopAppBar } from "@website/ui-old/top-app-bar";
import { isChannel } from "@website/utils/channel/helpers";
import { Header } from "@website/widget/header";
import { useRouter } from "next/router";
import { FC } from "react";
import { useHeaderWrapper } from "./header-wrapper.hook";
import styles from "./header-wrapper.module.scss";
import { HeaderWrapperPropertiesType } from "./header-wrapper.types";

export const HeaderWrapper: FC<HeaderWrapperPropertiesType> = () => {
  const { headerProperties, topAppBarProperties, scrolled } =
    useHeaderWrapper();
  const { isDesktop } = useViewPort();
  const { pathname } = useRouter();

  if (isDesktop) {
    return isChannel(["jek"]) ? null : (
      <div className={styles["container"]}>
        <div
          className={`${styles["fix-layer"]} ${
            scrolled ? styles["scrolled"] : ""
          }`}
        >
          <Header {...headerProperties} />
        </div>
      </div>
    );
  }
  if (
    pathname === "/user-management" ||
    pathname === "/passengers-list" ||
    pathname === "/my-trips" ||
    pathname === "/my-trips/details/hotel-domestic/[trackingId]" ||
    pathname === "/my-trips/details/hotel-international/[trackingId]" ||
    pathname === "/my-trips/details/flight-domestic/[referenceId]" ||
    pathname === "/my-trips/details/flight-international/[trackingId]" ||
    pathname === "/my-trips/details/villa/[trackingId]" ||
    pathname === "/my-trips/details/train/[trackingId]" ||
    pathname === "/my-trips/details/bus/[trackingCode]" ||
    pathname === "/my-trips/details/tour/[trackingId]" ||
    pathname === "/information" ||
    pathname === "/transactions" ||
    pathname === "/wallet" ||
    pathname === "/upload-history" ||
    pathname === "/trip-management"
  ) {
    return null;
  }
  return <TopAppBar {...topAppBarProperties} />;
};
